/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchcountries1Inputs */

const en_searchcountries1 = /** @type {(inputs: Searchcountries1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search countries...`)
};

const de_searchcountries1 = /** @type {(inputs: Searchcountries1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länder suchen…`)
};

/**
* | output |
* | --- |
* | "Search countries..." |
*
* @param {Searchcountries1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchcountries1 = /** @type {((inputs?: Searchcountries1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchcountries1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchcountries1(inputs)
	return de_searchcountries1(inputs)
});
export { searchcountries1 as "searchCountries" }